import { Page } from "@components-common/layouts";
import { ScreenProps } from "@components-common/types";

export const custom: Omit<ScreenProps,"id"> & {id?: string} = {
  type: 'index',
  cat: 'screen',
  view: {
    type: 'index',
    cat: 'page',
    Component: Page, // (()=>{}) as any,//Page,
    props: {
      title: 'CUSTOM_TITLE_NOT_SET'
    },
    children: [

    ]
  },
  route: {
    to: '/custom',
    roles: [],
    protected: false
  } as any
};
